<div class="row justify-content-md-center">
  <div class="col-sm-12 col-md-6 col-md-auto">

    <!-- Sign In -->
    <div class="sign__container">

      <div style="margin-bottom: 30px; text-align: center;">
        <a href="http://www.telego.com/" style="box-sizing: border-box; color: #2196F3; text-decoration: none;">
          <img alt="TeleGo" style="-ms-interpolation-mode: bicubic; max-width: 100%;"
               src="../../../assets/images/logo-with-slogan.svg">
        </a>
      </div>

      <div class="card card-default">

        <div class="card-body">
          <h4 class="card-title">Log in to Your Account</h4>
          <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
              Invalid username or password
            </div>
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="verifyTokenError">
              Token is invalid or expired
            </div>
            <div class="alert alert-success alert-dismissible" role="alert" *ngIf="resetSuccess">
              Please check your email. We've sent you a link to a page where you can create a new password.
            </div>
            <div *ngIf="!twoFactorSecondStep">
              <app-mat-text-input formControlName="username" label="Username" name="username"
                                  [submitted]="submitted"></app-mat-text-input>
              <app-mat-password-input formControlName="password" label="Password" name="password"
                                      [submitted]="submitted"></app-mat-password-input>
            </div>
            <div *ngIf="twoFactorSecondStep">
              <p>{{twoFactorTokenHint}}</p>
              <app-mat-text-input formControlName="token" label="Verification token" name="token"
                                  [submitted]="submitted"></app-mat-text-input>
              <button type="button" mat-stroked-button *ngIf="twoFactorSource"
                      style="margin-bottom: 10px; margin-top: 20px; width: 100%" (click)="resendSmsCode()">
                Resend Code
              </button>

              <button type="submit" mat-raised-button color="primary"
                      style="margin-bottom: 10px; margin-top: 20px; width: 100%" [promiseBtn]="buttonSubmitPromise">
                Verify Code
              </button>
            </div>
            <button type="submit" mat-raised-button color="primary" *ngIf="!twoFactorSecondStep"
                    style="margin-bottom: 10px; margin-top: 20px; width: 100%" [promiseBtn]="buttonSubmitPromise">
              Sign In
            </button>

            <a *ngIf="!twoFactorSecondStep" href="/api/auth/google/login" mat-raised-button style="margin-left: 0; width: 100%">
              <span class="icon"></span>
              <span class="buttonText">Sign in with Google</span>
            </a>

            <a *ngIf="!twoFactorSecondStep" href="/api/auth/microsoft/login" mat-raised-button style="margin-left: 0; margin-top: 10px; width: 100%">
              <span class="icon-microsoft">
                <img src="/assets/images/microsoft.svg" alt="Microsoft Logo" />
              </span>
              <span class="buttonText">Sign in with Microsoft</span>
            </a>
          </form>
        </div> <!-- / .panel-body -->

        <div class="card-footer">
          <a (click)="forgotPasswordClick()" style="font-size: 15px;">Forgot your password?</a>
          <div class="collapse" [class.show]="showForgotPassword">
            <form fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px" [formGroup]="forgotForm" novalidate
                  (ngSubmit)="onForgotPasswordSubmit()">
              <app-mat-text-input formControlName="username" fxFlex label="Enter your e-mail"
                                  [inlineLabel]="true" name="username"
                                  [submitted]="submittedReset"></app-mat-text-input>
              <button mat-button class="bottom-m" type="submit" [promiseBtn]="resetButtonSubmitPromise">
                Reset
              </button>
            </form>
          </div>
        </div> <!-- / .card-footer -->

      </div> <!-- / .card -->

      <p class="sign__extra text-muted text-center" style="font-size: 15px;">
        Interested in learning more about TeleGo? <a href="https://telego.com/get-started/">Contact us!</a>
      </p>

    </div> <!-- / .sign__conteiner -->

  </div>
</div>
<footer class="page__footer custom">
  <div class="row">
    <div class="col-xs-12 page__footer__holder">
      <span class="page__footer__year">{{currentYear}}</span> © TeleGo Inc. ® All rights reserved.
      <a href="https://kb.telego.com/article/110-privacy-policy" target="_blank">Privacy</a> and
      <a href="https://kb.telego.com/article/111-telego-terms-and-conditions" target="_blank">Terms</a>
    </div>
  </div>
</footer>
